import type {FC} from 'react';
import NoStreamingImg from '../../../assets/broadcast/no_streaming.png';
import {BackgroundVideo} from '../types/Streaming.styled.ts';
import useGlobalStore from '../../../store/useGlobalStore.ts';

const NoStreaming: FC = () => {
    const {isFullScreen} = useGlobalStore();

    return (
        <BackgroundVideo $isFullScreen={isFullScreen}>
            <img
                style={{width: '100%', height: '100%', overflow: 'hidden'}}
                src={NoStreamingImg}
                alt="방송이 종료되었습니다."
            />
        </BackgroundVideo>
    );
};

export default NoStreaming;
